module.exports = __webpack_public_path__ + "static/media/tv-show-img1.c4e5b63c.png";